import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-x4 lg:mb-x8" }
const _hoisted_2 = { class: "mr-x2" }
const _hoisted_3 = {
  key: 0,
  class: "bg-brandy o-text-body relative bottom-3 text-12 font-montserrat mb-14 px-8 py-4 sm:py-8 whitespace-nowrap"
}

import { computed } from 'vue';
import { GlobalLabels } from '@/shared/content/site-context.store';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import dictionaryService from '@/core/dictionary/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailIntro',
  props: {
    name: { default: '' },
    designer: { default: undefined },
    splashLabel: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { name: string, designer: string, splashLabel: string }



const globalLabels = useGlobalLabels(GlobalLabels.product);

const designerLabel = computed(() => {
    return dictionaryService.formatNamed(globalLabels.designedBy, { designer: props.designer });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "o-anim-fade-200",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("h1", {
          key: __props.name,
          class: "mb-x1 lg:mb-x1 leading-12 relative"
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.name), 1),
          (__props.splashLabel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.splashLabel), 1))
            : _createCommentVNode("", true)
        ]))
      ]),
      _: 1
    }),
    (__props.designer)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "o-anim-fade-200",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("p", {
              key: _unref(designerLabel),
              class: "o-text-h4 font-cormorant italic mb-x3 lg:mb-x3"
            }, _toDisplayString(_unref(designerLabel)), 1))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})